import dayjs from 'dayjs';

export const INITIAL_SEARCH_PARAMS = {
    startDate: dayjs().subtract(1, 'month'),
    endDate: dayjs(),
    customer_name: '',
    manager: '',
    managerId: '',
    invoice_no: '',
    invoice_date: '',
    due_date: '',
    currency: '',
    amount: '',
    vat_amount: '',
    total_amount: '',
    received_amount: '',
    status: '',
    status_account_receivable: ''
};

export const INITIAL_ALERT_INFO = {
    open: false,
    title: '',
    message: '',
    severity: 'info',
    onConfirm: null,
    onClose: null
};

export const getBasicColumns = (t) => [
    {
        id: 'invoice_date',
        label: t('invoice.invoiceDate'),
        minWidth: 120,
        align: 'center',
        format: (value) => value || '-'
    },
    {
        id: 'customer_name',
        label: t('orders.columns.custom'),
        minWidth: 150,
        align: 'left',
        format: (value) => value || '-'
    },
    {
        id: 'manager_name',
        label: t('orders.columns.name'),
        minWidth: 150,
        align: 'left',
        format: (value) => value || '-'
    },
    {
        id: 'invoice_no',
        label: t('invoice.invoiceNo'),
        minWidth: 120,
        align: 'left',
        format: (value) => value || '-'
    },
    {
        id: 'due_date',
        label: t('invoice.dueDate'),
        minWidth: 120,
        align: 'center',
        format: (value) => value || '-'
    },
    {
        id: 'currency',
        label: t('invoice.currency'),
        minWidth: 80,
        align: 'center',
        format: (value) => value || '-'
    },
    {
        id: 'amount',
        label: t('invoice.amount'),
        minWidth: 120,
        align: 'right',
        format: (value) => value ? Number(value).toLocaleString() : '-'
    },
    {
        id: 'vat_amount',
        label: t('invoice.vatAmount'),
        minWidth: 120,
        align: 'right',
        format: (value, row) => {
            const vat1 = Number(row.vat_amount) || 0;
            const vat2 = Number(row.vat_amount_2) || 0;
            const totalVat = vat1 + vat2;
            return totalVat > 0 ? totalVat.toLocaleString() : '-';
        }
    },
    {
        id: 'total_amount',
        label: t('invoice.totalAmount'),
        minWidth: 120,
        align: 'right',
        format: (value) => value ? Number(value).toLocaleString() : '-'
    },
    {
        id: 'received_amount',
        label: t('invoice.columns.payment'),
        minWidth: 120,
        align: 'right',
        format: (value) => value ? Number(value).toLocaleString() : '-'
    },
    {
        id: 'status',
        label: t('invoice.status'),
        minWidth: 120,
        align: 'center',
        format: (value) => {
            const statusMap = {
                'issued': t('invoice.statusOptions.issued'),
                'canceled': t('invoice.statusOptions.canceled'),
                'completed': t('invoice.statusOptions.completed'),
                'paid': t('invoice.statusOptions.paid'),
                'partial_paid': t('invoice.statusOptions.partial_paid')
            };
            return statusMap[value] || value || '-';
        },
        render: (value) => {
            const statusConfig = {
                'issued': { color: 'primary', variant: 'outlined' },
                'canceled': { color: 'error', variant: 'filled' },
                'completed': { color: 'success', variant: 'filled' },
                'paid': { color: 'success', variant: 'filled' },
                'partial_paid': { color: 'warning', variant: 'filled' }
            };
            
            const config = statusConfig[value] || { color: 'default', variant: 'outlined' };
            const statusMap = {
                'issued': 'invoice.statusOptions.issued',
                'canceled': 'invoice.statusOptions.canceled',
                'completed': 'invoice.statusOptions.completed',
                'paid': 'invoice.statusOptions.paid',
                'partial_paid': 'invoice.statusOptions.partial_paid'
            };
            
            return {
                type: 'chip',
                label: statusMap[value] || value || '-',
                color: config.color,
                variant: config.variant,
                size: 'small'
            };
        }
    },
    {
        id: 'status_account_receivable',
        label: t('invoice.columns.paymentStatus'),
        minWidth: 120,
        align: 'center',
        format: (value) => {
            const statusMap = {
                'paid': t('invoice.statusOptions.paid'),
                'unpaid': t('invoice.statusOptions.unpaid'),
                'partial_paid': t('invoice.statusOptions.partial_paid'),
                'partial': t('invoice.statusOptions.partial_paid'),
                'overdue': t('invoice.statusOptions.overdue'),
                'issued': t('invoice.statusOptions.unpaid'),
                'canceled': t('invoice.statusOptions.canceled')
            };
            return statusMap[value] || value || '-';
        },
        render: (value) => {
            const statusConfig = {
                'paid': { color: 'success', variant: 'filled' },
                'unpaid': { color: 'error', variant: 'filled' },
                'partial_paid': { color: 'warning', variant: 'filled' },
                'partial': { color: 'warning', variant: 'filled' },
                'overdue': { color: 'error', variant: 'outlined' },
                'issued': { color: 'error', variant: 'filled' },
                'canceled': { color: 'error', variant: 'filled' }
            };
            
            const config = statusConfig[value] || { color: 'default', variant: 'outlined' };
            const statusMap = {
                'paid': 'invoice.statusOptions.paid',
                'unpaid': 'invoice.statusOptions.unpaid',
                'partial_paid': 'invoice.statusOptions.partial_paid',
                'partial': 'invoice.statusOptions.partial_paid',
                'overdue': 'invoice.statusOptions.overdue',
                'issued': 'invoice.statusOptions.unpaid',
                'canceled': 'invoice.statusOptions.canceled'
            };
            
            return {
                type: 'chip',
                label: statusMap[value] || value || '-',
                color: config.color,
                variant: config.variant,
                size: 'small'
            };
        }
    }
];

export const STATUS_OPTIONS = [
    { value: 'issued', label: 'invoice.statusOptions.issued' },
    { value: 'canceled', label: 'invoice.statusOptions.canceled' },
    { value: 'completed', label: 'invoice.statusOptions.completed' }
];

export const getPrintColumns = (t) => [
    { id: 'manager_name', label: 'MANAGER' },
    { id: 'buyer', label: 'BUYER' },
    { id: 'style_no', label: 'STYLE NO' },
    { id: 'file_no', label: 'FILE NO' },
    { id: 'factory', label: 'FACTORY' },
    { id: 'delivery_date', label: 'DELIVERY DATE' },
    { id: 'item', label: 'ITEM' },
    { id: 'size', label: 'SIZE' },
    { id: 'color', label: 'COLOR' },
    { id: 'qty', label: 'QTY' },
    { id: 'price', label: 'PRICE' },
    { id: 'vat', label: 'VAT' },
    { id: 'amount', label: 'AMOUNT' }
];

/** 인보이스 인쇄/미리보기 모달 `initialColumns` 기본값 (TableControls 컬럼 패널 초기화와 동일) */
export const getDefaultInvoicePrintCheckedColumns = (t) => {
    const initialState = {};
    getPrintColumns(t).forEach((column) => {
        if (column.id === 'manager_name' || column.id === 'factory' || column.id === 'vat') {
            initialState[column.id] = false;
        } else {
            initialState[column.id] = true;
        }
    });
    return initialState;
};